<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="error" class="alert_success" v-if="alert_error === true">{{message_error}}</v-alert>
      </v-slide-x-reverse-transition>
        <v-card>
            <div class="pa-3">
                <v-row>
                    <v-col cols="12">
                        <h3>กรุณาเลือกวัตถุดิบที่ต้องการสั่งซื้อ</h3>
                        <div class="mt-2">
                            <v-tabs grow>
                                <v-tab @click="page_detail(source_detail.id)" v-for="(source_detail,index) in source_page_list" :key="index">{{ source_detail.source_name }}</v-tab>
                            </v-tabs>
                            <div v-for="(select_detail,index) in select_all" :key="index">
                                <div class="d-flex align-center" v-if="page_source_id == select_detail.id">
                                    <v-checkbox color="primary" @change="checkedStatusAll(select_detail.id)" v-model="select_detail.check"></v-checkbox>
                                    <div>เลือกทั้งหมด</div>
                                </div>
                            </div>
                            <v-form ref="form_add" @submit.prevent="purchaseOrderNew()">
                                <div v-for="(type_list,index) in data" :key="index">
                                    <v-simple-table v-if="page_source_id == type_list.id">
                                        <thead>
                                            <tr>
                                                <th class="text-center border_header_purchase_order_new_list">
                                                    #
                                                </th>
                                                <th class="text-center border_header_purchase_order_new_list">
                                                    รายการ
                                                </th>
                                                <th class="text-center border_header_purchase_order_new_list">
                                                    Max
                                                </th>
                                                <th class="text-center border_header_purchase_order_new_list">
                                                    Min
                                                </th>
                                                <th class="text-center border_header_purchase_order_new_list">
                                                    คงเหลือ
                                                </th>
                                                <th class="text-center border_header_purchase_order_new_list">
                                                    ซื้อ
                                                </th>
                                                <th class="text-center border_header_purchase_order_new_list">
                                                    ราคาต่อหน่วย
                                                </th>
                                                <th class="text-center border_header_purchase_order_new_list">
                                                    ราคารวม
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(typeDetail,index_type) in type_list.typeList" :key="index_type">
                                            <tr>
                                                <td colspan="8" class="primary white--text">
                                                    {{ typeDetail.type_name }}
                                                </td>
                                            </tr>
                                            <tr v-for="(detail,index_detail) in typeDetail.detailList" :key="index_detail" :class="{ 'row-red': detail.stock < 0 }">
                                                <td class="text-center border_header_purchase_order_new_list">
                                                    <div class="d-flex justify-center align-center">
                                                        <v-checkbox color="primary" v-model="detail.checked_status"></v-checkbox>
                                                    </div>
                                                </td>
                                                <td class="text-center border_header_purchase_order_new_list">{{ detail.nameMaterial }}</td>
                                                <td class="text-center border_header_purchase_order_new_list">
                                                    {{ detail.max }}
                                                </td>
                                                <td class="text-center border_header_purchase_order_new_list">
                                                    {{ detail.min }}
                                                </td>
                                                <td class="text-center border_header_purchase_order_new_list" >
                                                    {{ detail.stock }}
                                                </td>
                                                <td class="text-center border_header_purchase_order_new_list py-2" width="30%">
                                                    <div class="d-flex align-center quantity_purchase_order_new_list">
                                                        <div>
                                                            <v-text-field hide-details="auto" v-model="detail.buy" type="number" :rules="[v => !!v || 'กรุณากรอกจำนวน']" required dense outlined v-if="detail.unit_type == 1"></v-text-field>
                                                            <v-text-field hide-details="auto" v-model="detail.buy_other" type="number" :rules="[v => !!v || 'กรุณากรอกจำนวน']" required dense outlined v-if="detail.unit_type == 2"></v-text-field>
                                                        </div>

                                                        <div class="ml-2">
                                                            <v-select v-if="detail.unit_other_name" v-model="detail.unit_type" :items="[{id: 1,unit_type_name:detail.unit_name,unit_type: detail.unit_id},{id: 2 ,unit_type_name:detail.unit_other_name,unit_type: detail.unit_other_id}]" item-text="unit_type_name" item-value="id" hide-details="auto" color="primary" dense outlined>
                                                            </v-select>
                                                            <v-select v-if="!detail.unit_other_name" v-model="detail.unit_type" :items="[{id: 1,unit_type_name:detail.unit_name,unit_type: detail.unit_id}]" item-text="unit_type_name" item-value="id" hide-details="auto" color="primary" dense outlined>
                                                            </v-select>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="text-center border_header_purchase_order_new_list">
                                                    {{ detail.unit_type == 1 ? detail.price : detail.price_other }}
                                                </td>
                                                <td class="text-center border_header_purchase_order_new_list">
                                                    {{ detail.unit_type == 1 ? currencyFormat(detail.buy * detail.price) : currencyFormat(detail.buy_other * detail.price_other) }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center border_header_purchase_order_new_list" colspan="7">
                                                    รวม
                                                </td>
                                                <td class="text-center border_header_purchase_order_new_list">
                                                    {{
                                                    currencyFormat(typeDetail.detailList.reduce((sum,detail) => {
                                                        if(detail.checked_status == true){
                                                            if(detail.unit_type == 1){
                                                                return sum + (detail.buy * detail.price)
                                                            }else{
                                                                return sum + (detail.buy_other * detail.price_other)
                                                            }
                                                        }else{
                                                            return sum + 0
                                                        }
                                                    }, 0))
                                                }}

                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-simple-table>

                                </div>
                                <div class="mt-3 text-center">
                                    <v-btn color="#28ab28" type="submit" class="white--text" width="20%" height="50">
                                        บันทึก
                                    </v-btn>
                                </div>

                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </div>
        </v-card>
        <v-dialog v-model="open_alert_show_add" persistent max-width="600">
            <v-card>
                <v-card-title>
                    สำเร็จ
                </v-card-title>

                <v-card-text>
                    สร้างใบสั่งซื้อสินค้าเรียบร้อย
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text @click="confirmSuccess()">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="open_alert_show_edit" persistent max-width="600">
            <v-card>
                <v-card-title>
                    สำเร็จ
                </v-card-title>

                <v-card-text>
                    แก้ไขใบสั่งซื้อสินค้าเรียบร้อย
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" text @click="confirmSuccess()">
                        ตกลง
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>
</template>

<script>
import stockpurchaseorder from '@/api/stock/stocklist/stockpurchaseorder.js'
import {
    currencyFormat
} from '@/helper/numberformat.js'

export default {
    props: ['page_id'],
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            open_alert_show_add: false,
            open_alert_show_edit: false,
            alert_error: false,
            message_error: '',
            page_source_id: null,
            select_all: [],
            source_page_list: [],
            data: [],
            sum_test: 0
        }
    },
    methods: {
        currencyFormat,
        async purchaseOrderNewList() {
            this.loading_page = true
            this.data = []
            if (this.$props.page_id) {
                stockpurchaseorder.purchaseOrderNewDetail(this.$props.page_id).then((response) => {
                    if (response.data.successful === true) {
                        response.data.po_list.forEach((detail, index) => {
                            if (index == 0) {
                                this.page_source_id = detail.id
                            }
                            this.select_all.push({
                                id: detail.id,
                                check: false
                            })
                            this.source_page_list.push({
                                id: detail.id,
                                source_name: detail.source_name,
                            })
                        })
                        this.data = response.data.po_list
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
            } else {
                stockpurchaseorder.purchaseOrderNewList().then((response) => {
                    if (response.data.successful === true) {
                        response.data.material.forEach((detail, index) => {
                            if (index == 0) {
                                this.page_source_id = detail.id
                            }
                            this.select_all.push({
                                id: detail.id,
                                check: false
                            })
                            this.source_page_list.push({
                                id: detail.id,
                                source_name: detail.source_name,
                            })
                        })
                        this.data = response.data.material
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

            }

        },
        async page_detail(id) {
            this.page_source_id = id
        },
        async checkedStatusAll(id) {
            let select = this.select_all.find((detail) => {
                return detail.id == id
            })
            let source_name = this.data.find((detail) => {
                return detail.id == id
            })

            source_name.typeList.forEach((typeDetail) => {
                typeDetail.detailList.forEach((detail) => {
                    detail.checked_status = false
                })
            })

            if (select.check) {
                source_name.typeList.forEach((typeDetail) => {
                    typeDetail.detailList.forEach((detail) => {
                        detail.checked_status = true
                    })
                })
            }
        },
        async purchaseOrderNew() {
            if (this.$refs.form_add.validate()) {
                this.loading_page = true

                if (this.$props.page_id) {
                    let total_price_arr = this.data.map((source_list) =>
                        source_list.typeList.map((type_list) =>
                            type_list.detailList.reduce((sum, detail) => {
                                if (detail.checked_status == 1) {
                                    if (detail.unit_type == 1) {
                                        return sum + (detail.buy * detail.price)
                                    } else {
                                        return sum + (detail.buy_other * detail.price_other)
                                    }
                                } else {
                                    return sum + 0
                                }
                            }, 0)
                        )
                    ).flat(Infinity)

                    let total_price = total_price_arr.reduce((sum, detail) => {
                        return sum + detail
                    }, 0)
                    const data = {
                        purchase_order_list_id: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    return detail_list.id
                                })
                            )
                        ).flat(Infinity),
                        quantity: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    if (detail_list.unit_type == 1) {
                                        return parseFloat(detail_list.buy)
                                    } else {
                                        return parseFloat(detail_list.buy_other)
                                    }
                                })
                            )
                        ).flat(Infinity),
                        price: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    if (detail_list.unit_type == 1) {
                                        return parseFloat(detail_list.price)
                                    } else {
                                        return parseFloat(detail_list.price_other)
                                    }
                                })
                            )
                        ).flat(Infinity),
                        unit_id: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    if (detail_list.unit_type == 1) {
                                        return detail_list.unit_id
                                    } else {
                                        return detail_list.unit_other_id
                                    }
                                })
                            )
                        ).flat(Infinity),
                        unit_type: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    return detail_list.unit_type
                                })
                            )
                        ).flat(Infinity),
                        total: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    if (detail_list.unit_type == 1) {
                                        return detail_list.buy * detail_list.price
                                    } else {
                                        return detail_list.buy_other * detail_list.price_other
                                    }
                                })
                            )
                        ).flat(Infinity),
                        checked_status: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    return detail_list.checked_status == 0 || detail_list.checked_status == false ? 0 : detail_list.checked_status == 1 || detail_list.checked_status == true ? 1 : null
                                })
                            )
                        ).flat(Infinity),
                        total_price: total_price,
                    }

                    stockpurchaseorder.editPurchaseOrderNewList(this.$props.page_id, data).then((response) => {
                        if (response.data.successful === true) {
                            this.open_alert_show_edit = true
                            this.loading_page = false
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                } else {
                    let total_price_arr = this.data.map((source_list) =>
                        source_list.typeList.map((type_list) =>
                            type_list.detailList.reduce((sum, detail) => {
                                if (detail.checked_status == 1) {
                                    if (detail.unit_type == 1) {
                                        return sum + (detail.buy * detail.price)
                                    } else {
                                        return sum + (detail.buy_other * detail.price_other)
                                    }
                                } else {
                                    return sum + 0
                                }
                            }, 0)
                        )
                    ).flat(Infinity)

                    let total_price = total_price_arr.reduce((sum, detail) => {
                        return sum + detail
                    }, 0)

                    const data = {
                        material_id: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    return detail_list.id
                                })
                            )
                        ).flat(Infinity),
                        quantity: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    if (detail_list.unit_type == 1) {
                                        return parseFloat(detail_list.buy)
                                    } else {
                                        return parseFloat(detail_list.buy_other)
                                    }
                                })
                            )
                        ).flat(Infinity),
                        price: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    if (detail_list.unit_type == 1) {
                                        return parseFloat(detail_list.price)
                                    } else {
                                        return parseFloat(detail_list.price_other)
                                    }
                                })
                            )
                        ).flat(Infinity),
                        unit_id: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    if (detail_list.unit_type == 1) {
                                        return detail_list.unit_id
                                    } else {
                                        return detail_list.unit_other_id
                                    }
                                })
                            )
                        ).flat(Infinity),
                        unit_type: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    return detail_list.unit_type
                                })
                            )
                        ).flat(Infinity),
                        total: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    if (detail_list.unit_type == 1) {
                                        return detail_list.buy * detail_list.price
                                    } else {
                                        return detail_list.buy_other * detail_list.price_other
                                    }
                                })
                            )
                        ).flat(Infinity),
                        checked_status: this.data.map((source_list) =>
                            source_list.typeList.map((type_list) =>
                                type_list.detailList.map((detail_list) => {
                                    return detail_list.checked_status == 0 || detail_list.checked_status == false ? 0 : detail_list.checked_status == 1 || detail_list.checked_status == true ? 1 : null
                                })
                            )
                        ).flat(Infinity),
                        total_price: total_price,
                    }
                    stockpurchaseorder.addPurchaseOrderNewList(data).then((response) => {
                        if (response.data.successful === true) {
                            this.open_alert_show_add = true
                            this.loading_page = false
                        }
                        else {
                          this.message_error = response.data.msg
                          this.alert_error = true
                          setTimeout(()=> this.alert_error = false, 3000)
                          this.loading_page = false
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
            }
        },
        async confirmSuccess() {
            this.$router.push('/purchaseorder')
        },
    },
    mounted() {
        this.purchaseOrderNewList()
    },
}
</script>

<style scoped>
.border_header_purchase_order_new_list {
    border: thin solid rgba(0, 0, 0, 0.12);
}

.quantity_purchase_order_new_list>div:first-child {
    width: 45%;
}

.quantity_purchase_order_new_list>div:last-child {
    width: 55%;
}

.row-red {
    /* background-color: #ff5252;  */
    color: #ff5252; /* เปลี่ยนตัวอักษรเป็นสีขาว (หรือเปลี่ยนตามความเหมาะสม) */
}
</style>
